import React from 'react';
import { Button, Chip, Stack, Tooltip } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { problemsFromValidationMap } from './ai/fixRequest';

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

/**
 * What is wrong with the flow, the same control in both builders.
 *
 * The canvas used to show an outlined "Validation" button with a badge counting errors AND
 * warnings; the assistant showed a "No problems" / "N problems" chip counting errors only. Same
 * question, two looks, two numbers. Both now count with one function over one validation map:
 * problems are builder errors plus WhatsApp's own verdict (they block publishing), warnings are
 * shown but do not. Clicking opens the same panel in either mode.
 */
const ValidationStatus = ({ validationMap, screens, meta, onOpen, onFix, busy = false }) => {
  const problems = problemsFromValidationMap(validationMap, screens, meta);
  const warningCount = validationMap?.totals?.warningCount || 0;
  const summary = problems.length
    ? problems.slice(0, 5).join('\n') + (problems.length > 5 ? `\n…and ${problems.length - 5} more` : '')
    : warningCount ? plural(warningCount, 'warning', 'warnings') + '. They do not stop the flow from publishing.' : '';

  const chip = problems.length ? (
    <Chip size="small" color="error" icon={<ErrorOutlineIcon />}
      label={plural(problems.length, 'problem', 'problems')}
      onClick={onOpen} data-testid="validation-status" />
  ) : warningCount ? (
    <Chip size="small" color="warning" variant="outlined" icon={<WarningAmberIcon />}
      label={plural(warningCount, 'warning', 'warnings')}
      onClick={onOpen} data-testid="validation-status" />
  ) : (
    <Chip size="small" color="success" variant="outlined" icon={<CheckCircleOutlineIcon />}
      label="No problems" onClick={onOpen} data-testid="validation-status" />
  );

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{summary}</span>}>{chip}</Tooltip>
      {problems.length > 0 && onFix && (
        <Button size="small" variant="contained" disableElevation
          startIcon={<AutoAwesomeIcon fontSize="small" />}
          onClick={() => onFix(problems)} disabled={busy} data-testid="validation-fix">
          Fix these
        </Button>
      )}
    </Stack>
  );
};

export default ValidationStatus;
